import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

import { environment } from '@ap/http';

import * as FullStory from '@fullstory/browser';

import { BrandingService } from '@library/common/branding';
import { HttpPagination } from '@library/common/http';
import {
   BrowserCheckService,
   BreakpointService,
   EnvironmentService,
   GoogleAnalyticsService,
   MaintenanceService,
   PortalService,
} from '@library/core/services';

@Component({
   selector: 'app-root',
   template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      public router: Router,
      public branding: BrandingService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private maintenance: MaintenanceService,
      private portalService: PortalService,
      private pagination: HttpPagination,
   ) {
      this.portalService.current = 'agent';
      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();
      this.maintenance.check();
      FullStory.init({ orgId: 'o-1MB0F2-na1', devMode: !environment.production });

      this.router.events.subscribe( event => {
         if ( event instanceof NavigationStart ) {
            const currentPath = this.router.url.split('?')[0];
            const nextPath = event.url.split('?')[0];
            // Query-only navigation on the same route (e.g. email-logs filter syncing
            // query params) should not abort in-flight requests or background pagination.
            if ( currentPath === nextPath ) { return; }
            this.pagination.stop(); // Stop background pagination to allow resumption
         }
      });
   }
}
